import { OPCO_ID } from '../../models/opco/opco.shared.types';

export const isAviosOpco = (opcoId: string | OPCO_ID): opcoId is OPCO_ID =>
  opcoId === OPCO_ID.BA || opcoId === OPCO_ID.IB || opcoId === OPCO_ID.EI;
